import React from "react";
import {
  FilePlus,
  X,
  Check,
  RefreshCw,
  ChevronFirst,
  ChevronLeft,
  ChevronRight,
  ChevronLast,
  ArrowDownAZ,
  ArrowUpAZ,
  Search,
  Filter,
  FilterX,
  Table2,
  Printer,
  PrinterCheck,
  UserRound,
  Euro,
  AtSign,
} from "lucide-react";
import { TID } from "@/constants/testIds";

/**
 * Toolbar de iconos al estilo Sage 200 Logic Class.
 * Cada botón es plano, hover ligero, separadores entre grupos.
 */
const GROUPS = [
  [
    { icon: FilePlus,     title: "Nuevo (Ctrl+N)",        tid: TID.sageBtnNew,      action: "new" },
    { icon: X,            title: "Anular",                tid: TID.sageBtnDelete,   action: "delete", danger: true },
    { icon: Check,        title: "Validar / Cobrar",      tid: TID.sageBtnValidate, action: "validate", primary: true },
    { icon: RefreshCw,    title: "Refrescar",             tid: TID.sageBtnRefresh,  action: "refresh" },
  ],
  [
    { icon: ChevronFirst, title: "Primero",   action: "first" },
    { icon: ChevronLeft,  title: "Anterior",  action: "prev" },
    { icon: ChevronRight, title: "Siguiente", action: "next" },
    { icon: ChevronLast,  title: "Último",    action: "last" },
  ],
  [
    { icon: ArrowDownAZ, title: "Ordenar asc",  action: "sort-asc" },
    { icon: ArrowUpAZ,   title: "Ordenar desc", action: "sort-desc" },
    { icon: Search,      title: "Buscar (Ctrl+F)", tid: TID.sageBtnSearch, action: "search", highlight: true },
    { icon: Filter,      title: "Filtrar",      action: "filter" },
    { icon: FilterX,     title: "Quitar filtro", action: "filter-clear" },
    { icon: Table2,      title: "Vista tabla",   action: "table" },
  ],
  [
    { icon: Printer,      title: "Imprimir", tid: TID.sageBtnPrint, action: "print" },
    { icon: PrinterCheck, title: "Imprimir + Validar", action: "print-validate" },
    { icon: UserRound,    title: "Cliente", tid: TID.sageBtnCustomer, action: "customer" },
    { icon: Euro,         title: "Cobro",   tid: TID.sageBtnEuro,     action: "cobro" },
    { icon: AtSign,       title: "Enviar por email", action: "email" },
  ],
];

export default function SageToolbar({ onAction }) {
  return (
    <div className="h-9 bg-[#F0F0F0] border-b border-slate-300 flex items-center px-1 gap-0">
      {GROUPS.map((group, gi) => (
        <React.Fragment key={gi}>
          {group.map((b, bi) => {
            const Icon = b.icon;
            return (
              <button
                key={bi}
                data-testid={b.tid}
                title={b.title}
                onClick={() => onAction?.(b.action)}
                className={`h-7 w-7 flex items-center justify-center rounded-sm border border-transparent hover:bg-white hover:border-slate-300 transition-colors ${
                  b.highlight ? "bg-pink-50 border-pink-300" : ""
                } ${b.danger ? "text-red-600" : "text-slate-700"} ${b.primary ? "text-emerald-700" : ""}`}
              >
                <Icon size={15} strokeWidth={2.2} />
              </button>
            );
          })}
          {gi < GROUPS.length - 1 && <div className="w-px h-5 bg-slate-300 mx-1" />}
        </React.Fragment>
      ))}
    </div>
  );
}
